import { render, staticRenderFns } from "./Flex.vue?vue&type=template&id=c98e34c2&scoped=true&"
import script from "./Flex.vue?vue&type=script&lang=js&"
export * from "./Flex.vue?vue&type=script&lang=js&"
import style0 from "./Flex.vue?vue&type=style&index=0&id=c98e34c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98e34c2",
  null
  
)

export default component.exports